import React, { Fragment } from 'react'
import Fade from 'react-reveal/Fade';
import HighlightPdf from './HighlightPdf';

function HighlightsBanner() {
    return (
        <Fragment>
            <div className='container governancemain motor' >
                <div className='row arrticleAndBlogs'>
                    <div className='col-sm-12 heads govbanner highlight'>
                        <Fade up delay={500}><h2 className="oswald">Financial Highlights</h2></Fade>
                    </div>
                    <div className='col-sm-12 heads text mymaxheight'>
                       <HighlightPdf/>
                    </div>                
                </div>
            </div>
        </Fragment>
    )
}

export default HighlightsBanner